import React from "react"
import compose from "recompose/compose"
import styled from "styled-components"
import { Label } from "@xingternal/winery-ui/lib/Label"
import { withi18n } from "@/helpers/hoc/withi18n"

const i18ns = {
  newLabel: "360_NEW",
}

const NewLabelBase = styled(Label).attrs({
  type: "eyeCatcher",
})`
  flex-shrink: 0;
`

const NewLabel = ({ newLabel }) => <NewLabelBase>{newLabel}</NewLabelBase>

const enhance = compose(withi18n(i18ns))
const EnhancedNewLabel = enhance(NewLabel)

export { EnhancedNewLabel as NewLabel, i18ns }
